import { render, staticRenderFns } from "./balanceJournalDetails.vue?vue&type=template&id=81063496&scoped=true&"
import script from "./balanceJournalDetails.vue?vue&type=script&lang=js&"
export * from "./balanceJournalDetails.vue?vue&type=script&lang=js&"
import style0 from "./balanceJournalDetails.vue?vue&type=style&index=0&id=81063496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81063496",
  null
  
)

export default component.exports